


















































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class Window extends Vue {
  @Prop({ default: null }) public tag : string; //サポートコンテンツ識別用のタグ
  @Prop({ default: false }) public left : boolean; 
  public showPopover:boolean = false;
  public showModal:boolean = false;
  public  items : Common.HelpContent[] = null;
  public item: Common.HelpContent = null;
  public currentIndex:number = null;
  public searchWord:string = null;

  public created(){
    this.$api.execute(new Common.HelpContentListQuery(this.$translate(this.tag))).then(contents=>{
        this.items = contents;
        this.totalPage = Math.ceil(this.items.length / this.displayCount);
        this.showPage(0);
    });
  }

  public onPopuped(){
      this.searchWord = null;
      this.$api.issueGA4trackevent(this.$route.path,'【よくあるご質問】ボタン押下');
      this.showPage(0);
    (this.$refs.popup as any)._toolpop.$tip.className += " cx_help_popover";    
    this.$nextTick(()=>{
        var body = ((this.$refs.popup as any)._toolpop.$tip as HTMLElement).getElementsByClassName('cx_help_items')[0] as HTMLElement;
        body.focus();
        body.addEventListener('focusout', this.closePopup);
    });
  }  

  public closePopup(e:any){
      if(e.relatedTarget != null && this.$el.contains(e.relatedTarget as HTMLElement)){
          //閉じてすぐ開く挙動を回避するため、親ボタン側でクローズさせる
      } else if(e.relatedTarget != null && (this.$refs.popup as any)._toolpop.$tip.contains(e.relatedTarget as HTMLElement)){
          //テキスト入力時はスルーする
      } else {
          //v-modelを更新する
          this.showPopover = false;  
      }
  }  

  public onItemClick(id: string, index:number){
    this.currentIndex = index;
    this.showPopover = false;

    this.$api.issueGA4trackevent(this.$route.path,'【よくあるご質問】個別コンテンツ遷移');

    //直リンクに変更
    window.open('https://support.s-flow.net/ja/articles/' + id, '_blank');

    //カウンターを更新
    this.$api.execute(new Common.HelpContentItemQuery(id));

    // this.$api.startWaitCusor();
    // this.$api.execute(new Common.HelpContentItemQuery(id)).then (res =>{
    //     this.$api.closeWaitCursor();
    //     this.item = res;
    //     this.showModal = true;
    // });
  }

  public move(index:number){
    this.currentIndex += index;
    var id = this.items[this.currentIndex].id;
    this.$api.startWaitCusor();    
    this.$api.execute(new Common.HelpContentItemQuery(id)).then (res =>{
        this.$api.closeWaitCursor();
        this.item = res;
    });      
  }

  
  public pageIndex:number = 0;
  public totalPage:number = 1;
  public activeItems: Common.HelpContent[] = null;
  public displayCount:number = 7;
  public showPage(index: number){
      if (index < 0 || index >= this.totalPage) return;
      this.pageIndex = index;
      this.activeItems = this.items.slice(this.displayCount * this.pageIndex, this.displayCount * (this.pageIndex + 1));
  }

  public moveToSupportCenter(){
    if (this.searchWord) this.$api.issueGA4trackevent(this.$route.path,'【よくあるご質問】サポートセンター遷移');      
    else  this.$api.issueGA4trackevent(this.$route.path,'【よくあるご質問】サポートセンタートップ');   
    if (this.searchWord) window.open(String.format('https://support.s-flow.net/ja/?q={0}',encodeURI(this.searchWord)), '_blank');
    else window.open('https://support.s-flow.net/ja/', '_blank');
  }
}
